import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';

import SideNode from 'src/components/ui/SideNode';
import IconButton from 'src/components/ui/IconButton';

const SideArea = ({ label, onEditLabel, items = [] }) => (
	<Box>
		{label && (
			<Typography variant="h3" mb={1}>
				{label}
				{onEditLabel && (
					<IconButton shape="rounded" size="small" onClick={onEditLabel}>
						<EditIcon fontSize="inherit" />
					</IconButton>
				)}
			</Typography>
		)}

		{Boolean(items.length) &&
			items.map((data) => (
				<Stack
					mt={data?.labelGroup ? 0.5 : 3}
					ml={data?.labelGroup && -1}
					key={data.id}
				>
					<SideNode {...data} />
				</Stack>
			))}
	</Box>
);

SideArea.propTypes = {
	label: PropTypes.string,
	onEditLabel: PropTypes.func,
	items: PropTypes.arrayOf(PropTypes.shape(SideNode.propTypes)),
};

export default SideArea;
